import { supabase } from "@/integrations/supabase/client";

export const useAuditLog = () => {
  const logStaffAccess = async (accessedStaffId: string | null, actionType: 'view' | 'update' | 'create' | 'delete') => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return;

      await supabase.functions.invoke('audit-staff-access', {
        body: {
          accessed_staff_id: accessedStaffId,
          action_type: actionType
        },
        headers: {
          Authorization: `Bearer ${session.access_token}`
        }
      });
    } catch (error) {
      console.error('Failed to log staff access:', error);
      // Don't throw error to avoid disrupting the main flow
    }
  };

  return { logStaffAccess };
};